 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-054765b0":"ec654c01","chunk-085409c4":"185b87f8","chunk-0ad0ca73":"fe56610c","chunk-38f9dcf8":"1960ded0","chunk-56ab9949":"012045e0","chunk-62e38887":"9d70bcfd","chunk-87d0e600":"4788bdcd","chunk-a421ec72":"9dff349a","chunk-099b85d2":"1b364e1d","chunk-22f3ba06":"a9ddfa67","chunk-2ac9905f":"50612bbf","chunk-2d20f987":"8b9d51f8","chunk-3167496f":"c7ddc6c2","chunk-35d72f07":"9c0707d7","chunk-3637141e":"2e462555","chunk-3985d6bb":"989ffa8f","chunk-4131a008":"98d09fa1","chunk-43b13758":"9e8f8c81","chunk-478cd751":"6698e674","chunk-4ce3e952":"05202850","chunk-58c4e120":"fc78ed8f","chunk-62522037":"644c0790","chunk-684982d6":"b9b59006","chunk-69b3a464":"846f8a2f","chunk-6c059322":"17c2b712","chunk-6c223ed4":"cb3293d7","chunk-6c800da9":"8070b4eb","chunk-7650db98":"2cf54bda","chunk-7aaccc62":"5072d2c6","chunk-7f52c46c":"0e762c78","chunk-9050502a":"d0a265de","chunk-97705c9e":"f9eccff8","chunk-a899df3c":"accab521","chunk-ab313df2":"3dba7d4e","chunk-b8abea8c":"96de8c41","chunk-cbaaa98c":"a0e64a00","chunk-d32bb658":"576cfa0c","chunk-d8805628":"b52d7eff","chunk-da343ed0":"6f476b9a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-085409c4":1,"chunk-0ad0ca73":1,"chunk-38f9dcf8":1,"chunk-56ab9949":1,"chunk-62e38887":1,"chunk-87d0e600":1,"chunk-a421ec72":1,"chunk-22f3ba06":1,"chunk-2ac9905f":1,"chunk-3167496f":1,"chunk-35d72f07":1,"chunk-3637141e":1,"chunk-3985d6bb":1,"chunk-4131a008":1,"chunk-43b13758":1,"chunk-478cd751":1,"chunk-4ce3e952":1,"chunk-62522037":1,"chunk-69b3a464":1,"chunk-6c059322":1,"chunk-6c223ed4":1,"chunk-6c800da9":1,"chunk-7650db98":1,"chunk-7aaccc62":1,"chunk-7f52c46c":1,"chunk-9050502a":1,"chunk-a899df3c":1,"chunk-ab313df2":1,"chunk-b8abea8c":1,"chunk-cbaaa98c":1,"chunk-d32bb658":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-054765b0":"31d6cfe0","chunk-085409c4":"e5250ac5","chunk-0ad0ca73":"16200e08","chunk-38f9dcf8":"0559f7f0","chunk-56ab9949":"67c11573","chunk-62e38887":"4885e083","chunk-87d0e600":"113eb87c","chunk-a421ec72":"940f3cd4","chunk-099b85d2":"31d6cfe0","chunk-22f3ba06":"8eb0526c","chunk-2ac9905f":"9f7b6a7b","chunk-2d20f987":"31d6cfe0","chunk-3167496f":"4a86d45d","chunk-35d72f07":"4a86d45d","chunk-3637141e":"7dc3898a","chunk-3985d6bb":"4b28ce08","chunk-4131a008":"83b0abef","chunk-43b13758":"53b587fb","chunk-478cd751":"a1d8b78f","chunk-4ce3e952":"7ddab144","chunk-58c4e120":"31d6cfe0","chunk-62522037":"c09727f9","chunk-684982d6":"31d6cfe0","chunk-69b3a464":"4a86d45d","chunk-6c059322":"4bd7a836","chunk-6c223ed4":"1e859563","chunk-6c800da9":"86f7fbdf","chunk-7650db98":"81bc8ee6","chunk-7aaccc62":"edcdc793","chunk-7f52c46c":"78dc911a","chunk-9050502a":"88600695","chunk-97705c9e":"31d6cfe0","chunk-a899df3c":"46bacf1b","chunk-ab313df2":"e03c90d5","chunk-b8abea8c":"660597de","chunk-cbaaa98c":"cd40c52c","chunk-d32bb658":"83bbf577","chunk-d8805628":"31d6cfe0","chunk-da343ed0":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/platform/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
